function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,6.5L17.5,3.5L20.5,6.5L17.5,9.5L14.5,6.5Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(154,154,154)",
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2,7.8L5,16L5,19L8,19L16.2,10.8",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(154,154,154)",
      strokeWidth: "1.8px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsNormal);
export default __webpack_public_path__ + "static/media/tools_normal.fee403008ba76fb12ba3d8d5b4f6ead7.svg";
export { ForwardRef as ReactComponent };